// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3XCxP","content":"Consent_content__2Hfk0","footer":"Consent_footer__L1k_O"};